var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolkswagenBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3266BC",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M28 12c8.8 0 16 7.2 16 16.01C44 36.81 36.8 44 28 44s-16-7.18-16-15.99S19.2 12 28 12zm-10.71 7.4l5.74 14.9 2.1-5.3h5.51l2.1 5.3 5.8-15.07a13.8 13.8 0 0 0-3.63-3.1L30.88 27H25.2l-4.04-10.91c-1.48.85-2.79 1.98-3.87 3.32zm23.57 3.75L34.32 40.2a13.77 13.77 0 0 0 6.54-17.05zM31.47 41.3l-.04-.35-3.55-9.19-3.55 9.2-.01.28a13.92 13.92 0 0 0 7.15.06zM21.4 40.05l-6.37-16.6a13.72 13.72 0 0 0 6.37 16.6zM28 14.27c1.2 0 2.39.15 3.52.45l-3.47 9.6-3.5-9.62c1.1-.28 2.26-.43 3.45-.43z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagenBig);
export default __webpack_public_path__ + "static/media/volkswagen--big.51073e376e46c16c572703502c9c8968.svg";
export { ForwardRef as ReactComponent };